<template>
  <VDialog
      v-if="isAnotherDateSelectionDialogOpen"
      :persistent="!isNeededVehicleFound && true"
      :value="isAnotherDateSelectionDialogOpen"
      :width="isNeededVehicleFound ? '398' : '425'"
      :contentClass="(!isNeededVehicleFound) ? '' : 'only-image'"
      :overlayColor="(!isNeededVehicleFound) ? 'grey darken-4' : 'grey lighten-5'"
      overlayOpacity="0.46"
  >
    <VCard
        v-if="!isNeededVehicleFound"
        class="w-100 py-4"
    >
      <VCardTitle class="pt-0">
        <h6 class="heading-6 textPrimary--text">
          {{ $t('checkout.noVehicleFound') }}
        </h6>
      </VCardTitle>
      <VCardText>
        <VRow
            class=""
            justify="center"
        >
          <img
              :src="require('@slg/web-customer-shared/src/assets/img/no-vehicle.svg')"
              :alt="$t('imageAlt.noVehicleFound')"
          >
        </VRow>
        <VRow>
          <VCol>
            <span
                v-if="isRoundTrip && !isNeededVehicleFound && (!isOutwardVehicleFound && !isReturnVehicleFound)"
                class="body-1"
                v-html="$t('checkout.warningNoVehiclesFoundFroRoundTrip')"
            />
            <span
                v-else-if="!isRoundTrip && !isOutwardVehicleFound"
                class="body-1"
                v-html="$t('checkout.warningOnlyOutward', { monthDay: getConvertedDate, type: getDateType, time: getFullTime})"
            />
            <span
                v-else-if="isRoundTrip && (!isOutwardVehicleFound || !isReturnVehicleFound)"
                class="body-1"
                v-html="$t('checkout.warningOnlyOneVehicleIsFoundForRoundTrip',
                        { monthDay: getConvertedDate, type: getDateType, time: getFullTime, tripType: getTripType })"
            />
          </VCol>
        </VRow>
      </VCardText>
      <VCardActions class="pb-0">
        <VBtn
            class="w-100 header__link"
            color="brandingPrimary"
            @click="closeDialog"
        >
          <span class="button textWhite--text">
            {{ $t('checkout.ok') }}
          </span>
        </VBtn>
      </VCardActions>
    </VCard>
    <div
        v-if="isNeededVehicleFound"
        class="image-wrapper d-flex flex-column align-center"
    >
      <img
          :src="require('@slg/web-customer-shared/src/assets/img/vehicle-is-found.svg')"
          :alt="$t('imageAlt.vehicleFound')"
      >
      <h5 class="heading-5 brandingPrimary--text">
        {{ $t('checkout.vehicleIsFound') }}
      </h5>
    </div>
  </VDialog>
</template>

<script lang="ts">
export default {
  name: 'SVehicleSearchResultDialog',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import DateTypeEnum from '@slg/web-customer-shared/src/enum/DateTypeEnum';
import STimeConverter from '@slg/web-customer-shared/src/utils/timeConverter';
import { useI18n } from '../../../composables';

const props = defineProps({
  isAnotherDateSelectionDialogOpen: {
    type: Boolean,
    default: false,
  },
  isOutwardVehicleFound: {
    type: Boolean,
    default: false,
  },
  isReturnVehicleFound: {
    type: Boolean,
    default: false,
  },
  isRoundTrip: {
    type: Boolean,
    default: false,
  },
  isNeededVehicleFound: {
    type: Boolean,
    default: false,
  },
  outwardState: {
    type: Object,
    default: () => {},
  },
  returnState: {
    type: Object,
    default: () => {},
  },
});

const emit = defineEmits(['trackGtmEventNoVehiclesFound', 'closeDialog']);

const { t } = useI18n();

const getConvertedDate = computed(() => {
  const { date } = !props.isOutwardVehicleFound ? props.outwardState : props.returnState;
  return STimeConverter.convertToMonthDayFormat(date);
});

const getDateType = computed(() => {
  const { type } = !props.isOutwardVehicleFound ? props.outwardState : props.returnState;
  return type === DateTypeEnum.DEPARTURE_TIME ? t('checkout.depart') : t('checkout.arrive');
});

const getFullTime = computed(() => {
  const { time } = !props.isOutwardVehicleFound ? props.outwardState : props.returnState;
  return `${time}`;
});

const getTripType = computed(() => (!props.isOutwardVehicleFound ? t('checkout.outward') : t('checkout.return')));

function closeDialog() {
  emit('trackGtmEventNoVehiclesFound');
  emit('closeDialog');
}
</script>
<style lang="scss" scoped>
</style>
